import React from 'react';
import { InputNumber, Select, Space, Tag } from 'antd';
import { ThunderboltOutlined } from '@ant-design/icons';
import type { SettingsController } from '../../hooks/useSettings';
import { CardHint, Field, SaveButton, SettingsCard, CONTROL_WIDTH } from './parts';

const intervalOptionsMobile = [
  { value: 60, label: '1 minute' },
  { value: 180, label: '3 minutes' },
  { value: 300, label: '5 minutes' },
  { value: 600, label: '10 minutes' },
  { value: 1200, label: '20 minutes' },
  { value: 1800, label: '30 minutes' },
];

export const MobileGatewayCard: React.FC<{ s: SettingsController }> = ({ s }) => (
  <SettingsCard
    title={<Space size={6}>Mobile Gateway<Tag color="blue" style={{ marginInlineEnd: 0 }}>Modems</Tag></Space>}
    icon={<ThunderboltOutlined />}
    loading={s.loading}
    extra={<SaveButton onClick={s.handleSaveMobile} loading={s.savingMobile} />}
  >
    <CardHint>
      These values apply only to servers marked as Mobile gateway. Modems reboot every 5–10 minutes,
      so we check them less frequently and use a higher latency threshold.
    </CardHint>
    <Field
      label="Check interval"
      hint="How often the scheduler re-checks each mobile-gateway server. Independent of the dedicated cadence."
    >
      <Select
        size="small"
        value={s.checkIntervalMobile}
        onChange={s.setCheckIntervalMobile}
        style={{ width: CONTROL_WIDTH }}
        options={intervalOptionsMobile}
      />
    </Field>
    <Field
      label="Max tunnel latency"
      hint="Modem tunnels are slower than dedicated links. Exceeding this marks the modem as DEGRADED."
    >
      <InputNumber
        size="small"
        value={s.proxyMaxLatencyMsMobile}
        onChange={(val) => s.setProxyMaxLatencyMsMobile(val ?? 3000)}
        min={1000}
        max={120000}
        step={500}
        style={{ width: CONTROL_WIDTH }}
        addonAfter="ms"
      />
    </Field>
    <Field label="Request timeout" hint="Per-request timeout for HTTP cascade through the modem proxy.">
      <InputNumber
        size="small"
        value={s.proxyTimeoutMsMobile}
        onChange={(val) => s.setProxyTimeoutMsMobile(val ?? 20000)}
        min={1000}
        max={120000}
        step={1000}
        style={{ width: CONTROL_WIDTH }}
        addonAfter="ms"
      />
    </Field>
  </SettingsCard>
);

export default MobileGatewayCard;
